export const API_CONFIG = {
 BASE_URL: 'https://neetprepapp.mystudyplace.in/backend/',

 ENDPOINTS: {
    USERDATA: 'UserData.php',
    LOGINUPDATE: 'LoginUpdate.php',
    SIGNUP: 'SignUp.php',
    PUSHDATA: 'PushData.php',
    UPDATEPROFILE: 'UpdateProfile.php',
    DELETEACCOUNT: 'DeleteAccount.php',
    USERBEFORELOGIN: 'UserBeforeLogin.php',
    APPITEMSUSEFETCH: 'AppItemsUseFetch.php',
    USERDOUBTSEND: 'UserDoubtSend.php',
    USERDOUBT: 'UserDoubt.php',
    APPINSTALLSEND: 'AppInstallSend.php',
    APPINSTALLSENDWB: 'AppInstallSendWB.php',
    USERAPPINSTALL: 'UserAppInstall.php',
    APPITEMSUSEPUSH: 'AppItemsUsePush.php',
 
  }
};